import { type Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { type DecorationSet } from '@atlaskit/editor-prosemirror/view';

export type SuggestionType = 'date';

type DateMetadata = {
	date: Date;
	matchedFormat: string;
	trailingDelimiter: string | null;
};

export interface InlineSuggestion {
	from: number;
	id: string;
	isPartial?: boolean;
	metadata: DateMetadata;
	suggestedNode: PMNode;
	to: number;
	type: SuggestionType;
}

export interface InlineSuggestionState {
	decorationSet: DecorationSet;
	inlineSuggestion: InlineSuggestion | null;
	inlineSuggestionSessionId: string | null;
	locale: string;
}

export enum ACTIONS {
	CLEAR_INLINE_SUGGESTION = 'CLEAR_INLINE_SUGGESTION',
	UPDATE_INLINE_SUGGESTION = 'UPDATE_INLINE_SUGGESTION',
	UPDATE_LOCALE = 'UPDATE_LOCALE',
}

export type InlineSuggestionAction =
	| { type: ACTIONS.CLEAR_INLINE_SUGGESTION }
	| {
			payload: {
				decorationSet: DecorationSet;
				inlineSuggestion: InlineSuggestion;
				inlineSuggestionSessionId: string | null;
			};
			type: ACTIONS.UPDATE_INLINE_SUGGESTION;
	  }
	| { payload: { locale: string }; type: ACTIONS.UPDATE_LOCALE };
